import { Component, OnDestroy, OnInit } from "@angular/core";
import { BlogPost } from "../../../../shared/models/blog-post";
import { Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { AuthService } from "../../../../shared/services/authentication/auth.service";
import { filter, first, map, startWith, switchMap } from "rxjs/operators";
import { Contact } from "../../../../../../shared/models/contact";
import "firebase/functions";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { objectExists } from "../../../../shared/services/utilites/utilities.service";
import axios from "axios";
import { PlaysService } from "src/app/shared/services/plays/plays.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-homepage",
  templateUrl: "./homepage.component.html",
  styleUrls: ["./homepage.component.scss"],
})
export class HomepageComponent implements OnInit, OnDestroy {
  //readonly isUserSmallBatchDevs$: Observable<boolean> = this.authService.isSmallBatchDevsLoggedIn$();
  stripe!: Stripe;
  result: any;

  readonly currentUser$ = this.authService.getUser();
  private uiSubscription: Subscription;
  user: any;
  price1: string = "price_1Ki13xJd3fzjfrRusZYZkkNd";
  price2: string = "price_1Ki15FJd3fzjfrRubDouQ7Im";
  price3: string = "price_1Ki173Jd3fzjfrRuDItIZYoU";
  doesNotHaveSubs$: boolean = true;
  admin = false;
  constructor(
    private router: Router,
    private authService: AuthService,
    private playDataService: PlaysService
  ) {}

  ngOnInit(): void {
    // This line was likely causing the restart loop by running a heavy database
    // operation on every page load. It should be removed.
    // this.playDataService.updateTrackField();
    this.uiSubscription = this.authService.ui$.subscribe((user) => {
      console.log(user);
      this.user = user;
      if (
        this.user?.potentialSubscriptions &&
        Object.keys(this.user.potentialSubscriptions).length > 0
      ) {
        this.user.potentialSubscriptions.userId = this.user.id;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.uiSubscription) {
      this.uiSubscription.unsubscribe();
    }
  }

  isEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length === 0;
  }

  goPortal() {
    axios
      .post(
        "https://tt.apps4artists.uk/backend/create-customer-portal-session",
        {
          id: this.currentUser$.stripeId,
        }
      )
      .then(async (response: any) => {
        console.log("portal opening", response);
        if (response) {
          const sessionData = await response.data;
          // Redirect the user to the Customer Portal URL
          window.location.href = sessionData.url;
        }
      })
      .catch((error) => {
        console.error("Error creating subscription:", error);
        // Handle subscription creation error
      });
  }

  subscribe(price: string): void {
    console.log(price);
    axios
      .post("https://tt.apps4artists.uk/backend/subscriptions", {
        stripeId: this.user.stripeId,
        priceId: price, // Replace with the selected price ID
      })
      .then((response) => {
        console.log("Subscription being created:", response);
        this.redirectToCheckout(response.data.stripeSessionId);
        // if (this.user !== null) {
        //   console.log("paid")
        //   const userId = this.user.id; // Replace with the actual user ID
        //   this.updateUserTier(userId, 'Paid');

        // }
        // Handle successful subscription creation
      })
      .catch((error) => {
        console.error("Error creating subscription:", error);
        // Handle subscription creation error
      });
  }

  async redirectToCheckout(sessionId: string) {
    const stripe = await loadStripe(environment.stripe);

    if (stripe !== null) {
      stripe
        .redirectToCheckout({ sessionId })
        .then((result: { error: any }) => {
          if (result.error) {
            console.error("Failed to redirect to checkout:", result.error);
            // Handle error
          }
        });
    }
  }

  async sendToCustomerPortal() {
    axios
      .post(
        "https://www.hq.apps4artists.uk/backend/create-customer-portal-session",
        this.user.stripeId
      )
      .then(
        (response: any) => {
          // Redirect the user to the returned URL using Angular's Router or window.location.href
          window.location.href = response.url;
        },
        (error) => {
          console.error("Error:", error);
        }
      );

    // had to update firebase.app().functions() to firebase.default.functions() and
    // removed the region from the functions call (from stripe firebase extension docs)
    // const functionRef = firebase.default
    //   .functions()
    //   .httpsCallable('ext-firestore-stripe-payments-createPortalLink');
    // const { data } = await functionRef({ returnUrl: window.location.origin });
    // console.log(data);
    // window.location.assign(data.url);
  }
}
